export enum EventNames {
    UserLogin = "user_login",
    UserRegistration = "user_registration",
    UserUpdate = "user_update",
    UserLead = "user_lead",
    UserLeadModularHouses = "user_lead_modular_houses"
}
export enum EventNames {
    UserLogin = "user_login",
    UserRegistration = "user_registration",
    UserUpdate = "user_update",
    UserLead = "user_lead",
    UserLeadModularHouses = "user_lead_modular_houses"
}
